import { lesson13Activity1, lesson13Activity2, lesson13Activity3, lesson13QA } from './assignments'
import { createChessboard } from '../../utils';
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 2,
        video: {
            src: 'img/videos/lesson_13/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        audio: { src: 'img/audio/lesson_13/1.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>He only has 5 more squares to visit! Finish his tour with c3 as your LAST square.'
        },
        chessboard: {
            board: lesson13Activity2({
                showIndicators: { allSides: true },
                position: '8/8/8/8/n7/8/8/8',
                assignmentClass: 'custom-sparepiece',
                next: 2
            }),
            positionFen: '8/8/8/8/n7/8/8/8 b - - 0 1'
        }
    },
    {
        id: 2,
        previous: 0,
        next: 4,
        video: {
            src: 'img/videos/lesson_13/2.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 3
        }
    },
    {
        id: 3,
        previous: 2,
        next: 4,
        audio: { src: 'img/audio/lesson_13/2.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>Move the Knight to all the squares on the board.'
        },
        chessboard: {
            board: lesson13Activity1({
                showIndicators: { allSides: true },
                position: '8/8/8/8/8/8/8/N7',
                assignmentClass: 'custom-sparepiece',
                next: 4
            }),
            positionFen: '8/8/8/8/8/8/8/N7 w - - 0 1'
        }
    },
    {
        id: 4,
        previous: 2,
        next: 7,
        video: {
            src: 'img/videos/lesson_13/3.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 5
        }
    },
    {
        id: 5,
        previous: 4,
        next: 7,
        audio: { src: 'img/audio/lesson_13/3.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>Select a piece and make a move to checkmate the Black king.'
        },
        chessboard: {
            board: lesson13Activity3({
                showIndicators: { allSides: true },
                position: 'rr5k/4N1pp/p4p2/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4',
                resultFen: 'rr5k/6pp/p4pN1/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                move: 'e7-g6',
                from: 'e7',
                to: 'g6',
                next: 6
            }),
            positionFen: 'rr5k/4N1pp/p4p2/q1n1p2Q/1p2P3/1B3P2/PPP3PP/1K1R4 w - - 0 1'
        }
    },
    {
        id: 6,
        previous: 4,
        next: 7,
        audio: { src: 'img/audio/lesson_13/4.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>Select a piece and make a move to checkmate the White king.'
        },
        chessboard: {
            board: lesson13Activity3({
                showIndicators: { allSides: true },
                position: '6k1/1p3p2/p4Rnp/6p1/2nP2b1/1NP3P1/PP3RKP/4r3',
                resultFen: '6k1/1p3p2/p4Rnp/6p1/3P2b1/1NP1n1P1/PP3RKP/4r3',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                move: 'c4-e3',
                from: 'c4',
                to: 'e3',
                next: 7
            }),
            positionFen: '6k1/1p3p2/p4Rnp/6p1/2nP2b1/1NP3P1/PP3RKP/4r3 b - - 0 1'
        }
    },
    {
        id: 7,
        previous: 4,
        next: 8,
        video: {
            src: 'img/videos/lesson_13/4.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 8
        }
    },
    {
        id: 8,
        previous: 7,
        next: 9,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: 'What is the Knight\'s Tour?',
            answer: [
                'A video game about the middle ages',
                'When Knights give castle tours',
                'A very old chess puzzle',
                'A way to describe a busy Knight'
            ],
            rightAnswer: 'A very old chess puzzle',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 9,
        previous: 7,
        next: 10,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: 'What is the goal of the Knight\'s Tour?',
            answer: [
                'To get to your opponent\'s side of the board',
                'To land on every square on the board',
                'To jump over every piece on the board',
                'For a Knight in the middle ages to travel to another country'
            ],
            rightAnswer: 'To land on every square on the board',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 10,
        previous: 7,
        next: 11,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: 'In a Closed Knight’s Tour...',
            answer: [
                'The Knight begins and ends on the same square',
                'The Knight starts on a1 and ends on h8',
                'The Knight begins and ends on a different square',
                'No one is allowed to watch because it is a private event'
            ],
            rightAnswer: 'The Knight begins and ends on the same square',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 11,
        previous: 7,
        next: 12,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: 'In an Open Knight\'s Tour...',
            answer: [
                'The Knight begins and ends on the same square',
                'The Knight starts on a1 and ends on h8',
                'The Knight begins and ends on a different square',
                'Everyone is allowed to watch because it is a public event'
            ],
            rightAnswer: 'The Knight begins and ends on a different square',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 12,
        previous: 7,
        next: 13,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: 'The Knight is a unique chess piece because...',
            answer: [
                'He is the only chess piece that can travel across the board in one move',
                'He is the only piece that can capture the King',
                'He is the only piece that can move two times in a row',
                'He is the only piece (other than a pawn) that can start a chess game'
            ],
            rightAnswer: 'He is the only piece (other than a pawn) that can start a chess game',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 13,
        previous: 7,
        next: 14,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: 'The Knight can play well on a crowded board because...',
            answer: [
                'He doesn’t need much space',
                'He can jump into open areas',
                'He only moves one square at a time',
                'He can stick to the edges away from other pieces'
            ],
            rightAnswer: 'He can jump into open areas',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xl'
        }
    },
    {
        id: 14,
        previous: 7,
        next: 15,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: 'How many squares could a Knight reach from the middle of a completely open board?',
            answer: [
                '4',
                '8',
                '12',
                '16'
            ],
            rightAnswer: '8',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 15,
        previous: 7,
        next: 16,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: 'What is White\'s best move?',
            answer: [
                'Nxb8',
                'Nc5',
                'Nc7',
                'Nb4'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: 'kn6/8/NK6/8/6p1/6P1/8/8'
                }),
                hint: true
            },
            rightAnswer: 'Nc7',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 16,
        previous: 7,
        next: 17,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: 'What is Black\'s best move?',
            answer: [
                'Na6',
                'Nc6',
                'Nd7',
                'b5'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: 'kn6/8/1K6/2N5/6p1/6P1/8/8',
                }),
                hint: true
            },
            rightAnswer: 'Nd7',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'md'
        }
    },
    {
        id: 17,
        previous: 7,
        next: 18,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: 'How many possible Knight moves or captures does White have?',
            highlightSquares: true,
            answer: [
                '4',
                '6',
                '8',
                '10'
            ],
            chessboard: {
                board: lesson13QA({
                    showIndicators: true,
                    position: 'r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R',
                    squares: [ '.square-b1', '.square-a4', '.square-b5', '.square-d5', '.square-e2', '.square-d4', '.square-e5', '.square-g5', '.square-h4', '.square-g1' ]
                }),
                hint: true
            },
            rightAnswer: '10',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md'
        },

    },
    {
        id: 18,
        previous: 7,
        next: null,
        audio: { src: null, stop: true },
        qa: {
            position: 'center',
            result: true,
            nextLesson: 'Lesson Fourteen',
            styleClass: 'xl'
        }
    }
];

let assets = [
    '/img/background_12.png',
    '/img/background_13.png',
    '/img/background_14.png'
]

let config = {
    config: lessonConfig,
    assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_13/index.js